import React, { ComponentProps, FC, useState } from 'react';
import { Badge, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaPlus } from 'react-icons/fa';

type Props = ComponentProps<typeof Button> & { readonly label?: string };

export const ButtonNewRecord: FC<Props> = (props) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  // If no label, use the old circular style
  if (!props.label) {
    return (
      <Button
        {...props}
        className={`btn-circle d-inline-flex align-items-center justify-content-center ${
          props.className || ''
        }`}
        onClick={props.onClick}
        variant={props.variant || 'primary'}
        data-toggle="tooltip"
        data-placement="left"
        title={t('New Record')}
        size={props.size || 'sm'}
        style={{ padding: 0, lineHeight: 1, ...props.style }}
      >
        <FaPlus size={11} style={{ display: 'block' }} />
      </Button>
    );
  }

  // Ghost style with badge for labeled buttons
  return (
    <Button
      {...props}
      className={`d-flex align-items-center gap-2 ${props.className || ''}`}
      onClick={props.onClick}
      data-toggle="tooltip"
      data-placement="left"
      title={t('New Record')}
      size={props.size || 'sm'}
      style={{
        fontWeight: 500,
        minWidth: '140px',
        background: isHovered ? '#0d6efd' : 'transparent',
        border: 'none',
        color: isHovered ? 'white' : '#495057',
        transition: 'all 0.3s ease',
        padding: '0.375rem 0.75rem',
        ...props.style,
      }}
      onMouseEnter={(e) => {
        setIsHovered(true);
        props.onMouseEnter?.(e);
      }}
      onMouseLeave={(e) => {
        setIsHovered(false);
        props.onMouseLeave?.(e);
      }}
    >
      <Badge
        bg="primary"
        className="d-flex align-items-center justify-content-center"
        style={{
          width: '24px',
          height: '24px',
          borderRadius: '50%',
          padding: 0,
        }}
      >
        <FaPlus size={12} />
      </Badge>
      <span style={{ color: isHovered ? 'white' : '#495057' }}>{props.label}</span>
    </Button>
  );
};
